import React, { useEffect, useState, useRef } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "./../../../components/card/card.jsx";
import CostBenefit from "./charts/cost-benefit";
import Forecast from "./charts/forecast";
import Sweating from "./charts/sweating";
import Option from "./charts/option";
import Fault from "./charts/fault";
import { useParams } from "react-router-dom";
function MachineList() {
  let { assetId } = useParams();
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">MACHINE</a>
            </li>
            <li className="breadcrumb-item active">Asset Replacement Detail</li>
          </ul>

          <h1 className="page-header">Asset Replacement Detail</h1>

          <hr className="mb-4" />
          <Card>
            <CardBody>
              <div style={{ padding: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    fontSize: 13,
                    marginBottom: "10px",
                    marginTop: "10px",
                  }}
                ></div>
                <div style={{ height: "500px" }}>
                  <CostBenefit assetId={assetId} />
                </div>
                <hr />
                <div style={{ height: "500px" }}>
                  <Forecast assetId={assetId} />
                </div>
                <hr />
                <div style={{ height: "500px" }}>
                  <Fault assetId={assetId} />
                </div>
                <hr />
                <div style={{ height: "500px" }}>
                  <Option assetId={assetId} />
                </div>
                <hr />
                <div style={{ height: "500px" }}>
                  <Sweating assetId={assetId} />
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default MachineList;
